import Api from '@common/services/api';

export const saveScreenOrder = async (
    organisationId: string,
    formId: string,
    order: string[]
  ) => {
    const components = order.map((id, index) => ({ id, index }));
    await Api.put(
      `/v1/organisations/${organisationId}/performance/forms/${formId}/components/reorder`,
      { components }
    );
  };
